import type { TourStep } from "../types";

// Orientation — the app shell (sidebar nav + account card), which is
// present on every page. Opens the tour's first leg on /suggestions,
// ahead of that page's own steps.
export const shellSteps: TourStep[] = [
  {
    title: "Welcome to Indorama ESS",
    description:
      "The Employee Suggestion Scheme. Employees submit improvement ideas, the WC and SC committees review them, and the department head closes them once implemented. This tour walks through the app — the register, the overview (where your role includes it), the submission form, and a suggestion in detail. Use Next to move on, or close it any time with Esc.",
  },
  {
    anchor: "nav-new-suggestion",
    title: "New Suggestion",
    description:
      "Opens the submission form. Departmental heads and above review rather than originate, so this row is hidden for them.",
  },
  {
    anchor: "nav-overview",
    title: "Overview",
    description:
      "Scheme-wide numbers — closure rate, timing, pipeline and breakdowns by status, category and department. Every figure drills into the matching list. Not shown when your only ESS role is Employee.",
  },
  {
    anchor: "nav-suggestions",
    title: "Suggestions",
    description:
      "The register of suggestions you are allowed to see — for an Employee, the ones you submitted and the ones submitted on your behalf. The count beside it is the total; filters and search live on the page itself.",
  },
  {
    anchor: "account-menu",
    title: "Your account",
    description:
      "My Profile, Change Password and View Workflow (the status pipeline as a diagram), Appearance — Light, Dark or Match system, and the Source Sans 3 brand font or your system's own, remembered on this device (printed reports stay on white paper) — and the Product Tour, which you can restart from any page.",
  },
  // No separate Appearance step: its row lives inside the account menu,
  // which is closed while the tour runs, so an `appearance-menu` step
  // would always be dropped by the DOM-presence filter.
];
